import { EventEmitter, Injectable } from '@angular/core'
import { Subscription } from 'rxjs'
import { Message } from '../models/message'

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  private interceptors: EventEmitter<Message> = new EventEmitter<Message>()
  private stream: EventEmitter<Message> = new EventEmitter<Message>()

  subscribe(listener: (message: Message) => void): Subscription {
    return this.stream.subscribe(listener)
  }

  intercept(listener: (message: Message) => void): Subscription {
    return this.interceptors.subscribe(listener)
  }

  broadcast(message: Message): void {
    this.interceptors.emit(message)
    if (message.visible) {
      this.stream.emit(message)
    }
  }
}
